import type { Vault, } from "@bracket/types";


export const PENNYWORKS_VAULT_POSITIONS = ( symbol: Vault["symbol"] ) => `
{
	vault(symbol: "${symbol}") {
		address
		symbol
		pennyworks_positions {
			symbol
			chain
			epoch
			timestamp
			balance
			collateral_usd
			debt_usd
			health_factor
			liquidation_threshold
			ltv
			position_at_risk
			equity
		}
	}
}
`;
